import qs from 'query-string';
import { initialQueryParamsSchema, ProductType, RefundFlowType } from 'views/types';

const parseStringEmpty = (v: unknown): string => (typeof v === 'string' ? v : '');
const parseStringBolean = (v: unknown): boolean => v === 'true';

export const formatInitialQueryParams = (query: string): initialQueryParamsSchema => {
  const {
    currencyTo,
    amountTo,
    token,
    currencyFrom,
    amountFrom,
    paymentIntentId,
    merchantId,
    languageIso2,
    companyName,
    pageMode,
    refundFlow = 'Full',
    productType,
  } = qs.parse(query);

  return {
    currencyTo: parseStringEmpty(currencyTo),
    companyName: parseStringEmpty(companyName),
    pageMode: parseStringBolean(pageMode),
    currencyFrom: parseStringEmpty(currencyFrom),
    amountFrom: parseStringEmpty(amountFrom),
    amountTo: parseStringEmpty(amountTo),
    token: parseStringEmpty(token),
    paymentIntentId: parseStringEmpty(paymentIntentId),
    merchantId: parseStringEmpty(merchantId),
    languageIso2: parseStringEmpty(languageIso2),
    refundFlow: parseStringEmpty(refundFlow) as RefundFlowType,
    productType: (parseStringEmpty(productType) || 'CryptoPay') as ProductType,
  };
};

export const preventScientificNotation = (
  value: number,
  options?: { maximumFractionDigits?: number },
) => {
  if (!value || Number.isNaN(value)) return value;
  const isRtl = document.documentElement.dir === 'rtl';
  const locale = isRtl ? 'en-US' : (navigator.language || 'en-US');
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: options?.maximumFractionDigits || 8,
    useGrouping: false,
  }).format(value);
};
